// extracted by mini-css-extract-plugin
module.exports = {"container":"EventTeaser__container","mediaLink":"EventTeaser__mediaLink","primaryLink":"EventTeaser__primaryLink","secondaryLink":"EventTeaser__secondaryLink"};